<template>
    <div>
        <div v-if="idx != 1" class="icp-info-wrap text-c f-999">
            <span class="info-item-title">备案号：</span>
            <a href="http://beian.miit.gov.cn" class="info-item-a powerby-item-cn f-999" target="_blank">津ICP备20002312号-4</a>
        </div>
        <div class="footer-placeholder-wrap"></div>
        <div class="footer footer-wrap">
            <div v-for='(item,index) of items' :class='[{on:index === idx}]' :key="index" @click="click(index)">
                <img :src="index===idx?item.iconSelect:item.icon" />
                <p :class="index===idx?'foorerThis':''">{{item.name}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Footer",
    props: ['idx'],
    data() {
        return {
            items: [{
                    name: "首页",
                    path: "/home",
                    icon: this.Images.icon_tabbar_home,
                    iconSelect: this.Images.icon_tabbar_home_cur,
                },
                {
                    name: "课程",
                    path: "/course",
                    icon: this.Images.icon_tabbar_course,
                    iconSelect: this.Images.icon_tabbar_course_cur,
                },
                {
                    name: "商城",
                    path: "/shop1",
                    icon: this.Images.icon_tabbar_shop,
                    iconSelect: this.Images.icon_tabbar_home_cur,
                },
                {
                    name: "我的",
                    path: "/mine",
                    icon: this.Images.icon_tabbar_mine,
                    iconSelect: this.Images.icon_tabbar_mine_cur,
                }
            ]
        };
    },
    methods: {
        // 方法
        click(index) {
            // if (index == 2) {
            //     window.location.href = this.items[index].path
            //     return;
            // }
            this.$router.push(this.items[index].path)
        }

    },
    created() {
        // 实例创建完成
    },
};
</script>
<style lang="less" scoped>
.icp-info-wrap {
    margin: 10px auto 10px;
}

.footer-placeholder-wrap {
    height: calc(5rem + env(safe-area-inset-bottom));
}

.footer {
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 10;
    display: flex;
    position: fixed;
    background: #fff;
    box-sizing: border-box;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    height: calc(5rem + constant(safe-area-inset-bottom));
    padding-bottom: calc(constant(safe-area-inset-bottom));
    height: calc(5rem + env(safe-area-inset-bottom));
    padding-bottom: calc(env(safe-area-inset-bottom));

    >div {
        width: 25%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
            display: block;
            width: 20px;
            height: 20px;
            object-fit: contain;
        }

        >p {
            font-size: 12px;
            font-weight: 500;
            color: #999999;
        }

        .foorerThis {
            color: #7282eb;
        }
    }
}
</style>